
const ErrorLabel: React.FC<{ error: string[] | null | undefined }> = ({ error }) => {
  if (!error) return null;
  return <div className='ml-2 small text-danger'>{error}</div>;
}

export default ErrorLabel
